import {LogLevel, Logger} from '../../context/logger/Logger';
import {LoggerRef} from '@volkswagen-onehub/inspect-fa-service';

export function createGetLoggerRef(logger: Logger) {
    return (name: string | undefined, consumerId: string): LoggerRef => {
        return {
            set logLevel(level: string) {
                logger.setUseHttp(false);
                const log = logger.getFeatureHubLogger(name, consumerId);
                if (log) {
                    log.currentLevel = level as LogLevel;
                }
            },
            get logLevel() {
                const log = logger.getFeatureHubLogger(name, consumerId);
                if (log) {
                    return log.currentLevel;
                }
                return 'error';
            }
        };
    };
}
